import { makeStyles } from 'tss-react/mui';

export const BREAK_POINT = 1320;

export default makeStyles()((theme) => ({
    root: {
        display: 'flex',
        padding: '16px 0',
        borderBottom: '1px solid #E0E0E0',
        justifyContent: 'space-between',
        alignItems: 'center',
        minHeight: 48,
        marginBottom: 48,
        [theme.breakpoints.down(BREAK_POINT)]: {
            marginBottom: 20,
            padding: 16
        }
    },
    header: {
        fontSize: 24,
        margin: 0
    }
}));
